// Reducers return the state they were given when an action changes nothing, so
// React skips rerendering every consumer of the context. A payload rebuilt from
// a fetch carries fresh arrays and Dates for data that did not change, so those
// compare by their contents rather than by identity.
export const sameValue = (a: unknown, b: unknown): boolean => {
  if (Object.is(a, b)) return true;
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((v, i) => Object.is(v, b[i]));
  }
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }
  return false;
};

/** True when merging `patch` onto `state` would change nothing. */
export const patchChangesNothing = <T extends object>(
  state: T,
  patch: Partial<T>
): boolean =>
  (Object.keys(patch) as (keyof T)[]).every((key) =>
    sameValue(state[key], patch[key])
  );
